import type {Root} from "./types";

export const getUser = (state: Root) => state.user;
